/**
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */
/*
角色组说明
00000000-0000-0000-0000-000000000000 '0'	游客         属于BIM平台，但是设计中啥菜单也看不到的人
00000000-0000-0000-0000-000000000001 '1'	设计中心_领导          TP_WorkGroup
00000000-0000-0000-0000-000000000002 '2'	设计中心_信息管理员     TP_WorkGroup
00000000-0000-0000-0000-000000000003 '3'	设计中心_技术经理   1.1    XMCH_OBSDef
00000000-0000-0000-0000-000000000004 '4'	设计中心_专业负责人  1.1.9    XMCH_OBSDef
00000000-0000-0000-0000-000000000005 '5'	设计中心_普通设校审人员   CZGL_staffArrang
*/
import Vue from 'vue';
import { getAccessToken, removeAccessToken, setAccessToken, clearAllCookie } from '@/utils/accessToken';
import { resetRouter } from '@/router';
import { title, tokenName, authentication } from '@/config';
import { isArray } from '@/utils/validate';

import {
  userLogin, //
  getUserDetails,
  getPrjListbyUser,
  getPrjListbyUserMarket,
  getPrjListbyUserDesign,
  getprjRoleInfoAPI,
} from '@/api/login';
//状态：存放一些通用的属性 保存的就是公共状态
const state = {
  accessToken: getAccessToken(),
  username: '',
  userId: '',
  userMajor: new Array(), //默认没有专业属性，不需要根据专业筛选数据
  majorroleMap: {},
  userTopRole: '0', //角色中最高权限
  isFilterTask: true, //是否需要过滤权限（ 4 5 需要，123 不需要）
  taskCodes: new Array(),
  roles: ['0'], //默认是游客 0
  orgId: '',
  orgName: '',
  avatar: 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif',
  userMenu: [],
  //设计的变量
  prjList: [],
  prjId: window.localStorage.getItem('prjId') || '45381C44-FF3B-4648-A017-90E64D7FC69A',
  prjName: window.localStorage.getItem('prjName') || '998-HK',
  prjTitle: window.localStorage.getItem('prjTitle') || '998-998-HK',
  prjCode: window.localStorage.getItem('prjCode') || '998-HK',
  prjType: window.localStorage.getItem('prjType') || '零星项目',
  prjListMarket: [],
  prjListDesign: {},
};
/*getters属性理解为所有组件的computed属性,
也就是计算属性.
vuex的官方文档也是说到可以将getter理解为store的计算属性,
 getters的返回值会根据它的依赖被缓存起来，
 且只有当它的依赖值发生了改变才会被重新计算。
*/
const getters = {
  //钢筋参数 待删除
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  userId: (state) => state.userId,
  avatar: (state) => state.avatar,
  userRoles: (state) => state.roles,
  userMenu: (state) => state.userMenu,

  //设计参数
  // prjId: (state) => state.prjtId,
  // prjName: (state) => state.prjName,
  // prjTitle: (state) => state.prjTitle,
  // prjCode: (state) => state.prjCode,
  prjList: (state) => state.prjList,
  prjInfo: (state) => {
    return {
      prjId: state.prjId,
      prjName: state.prjName,
      prjTitle: state.prjTitle,
      prjCode: state.prjCode,
      prjType: state.prjType,
    };
  },
  prjListMarket: (state) => state.prjListMarket,
  prjListDesign: (state) => state.prjListDesign,

  prjType: (state) => state.prjType,
  userInfo: (state) => {
    return {
      userId: state.userId,
      username: state.username,
      orgId: state.orgId,
      orgName: state.orgName,
      userRoles: state.roles,
      userMajor: state.userMajor,
      userTopRole: state.userTopRole,
      majorroleMap: state.majorroleMap, //majorroleMap  {P: "4", PN: "4", O: "5"}
      major_pay: Object.keys(state.majorroleMap).filter((tmp) => {
        if (state.majorroleMap[tmp] <= 4) {
          return tmp;
        }
      }), //登录人可以发绩效的专业
      isFilterTask: state.isFilterTask,
      taskCodes: state.taskCodes,
    };
  },
};
//改变state的唯一方式就是通过mutations进行更改
//mutaions理解为store中的methods,
// mutations对象中保存着更改数据的回调函数,
// 该函数名官方规定叫type,
// 第一个参数是state,
//  第二参数是payload,
//  也就是自定义的参数.

const mutations = {
  /**
   * @description 设置accessToken
   * @param {*} state
   * @param {*} accessToken
   */
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
    setAccessToken(accessToken);
  },
  /**
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username;
  },
  setUserId(state, userId) {
    state.userId = userId;
  },

  setOrgId(state, orgId) {
    state.orgId = orgId;
  },
  setOrgName(state, orgName) {
    state.orgName = orgName;
  },

  /**
   * @description 设置头像
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },

  setMajors(state, majors) {
    state.userMajor = majors;
  },
  setUserTopRole(state, userTopRole) {
    state.userTopRole = userTopRole;
  },
  //majorroleMap
  setmajorroleMap(state, majorroleMap) {
    state.majorroleMap = majorroleMap;
  },

  setIsFilterTask(state, isFilterTask) {
    state.isFilterTask = isFilterTask;
  },
  setTaskCodes(state, taskCodes) {
    state.taskCodes = taskCodes;
  },

  setUserMenu(state, menu) {
    state.userMenu = menu;
  },
  setPrjList(state, prjList) {
    state.userMenu = prjList;
  },
  setPrjListMarket(state, prjListMarket) {
    state.userMenu = prjListMarket;
  },
  setPrjListDesign(state, prjListDesign) {
    state.userMenu = prjListDesign;
  },

  //设计：改变项目信息
  chgPrjInfo(state, prj) {
    if (prj.id != null) state.prjId = prj.id.toUpperCase();
    if (prj.name != null) state.prjName = prj.name;
    if (prj.title != null) state.prjTitle = prj.title;
    if (prj.code != null) state.prjCode = prj.code;
    window.localStorage.setItem('prjId', prj.id.toUpperCase());
    window.localStorage.setItem('prjName', prj.name);
    window.localStorage.setItem('prjTitle', prj.title);
    window.localStorage.setItem('prjCode', prj.code);
  },
  chgPrjType(state, type) {
    state.prjType = type;
    window.localStorage.setItem('prjType', type);
  },
};
//actions 类似于 mutations，不同在于：
// actions提交的是mutations而不是直接变更状态
// actions中可以包含异步操作, mutations中绝对不允许出现异步
// actions中的回调函数的第一个参数是context, 是一个与store实例具有相同属性和方法的对象
const actions = {
  /**
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  async login({ commit }, userInfo) {
    let userRes = await userLogin(userInfo);
    if (userRes.message == 'ok') {
      const accessToken = userRes.result;
      if (accessToken) {
        commit('setAccessToken', accessToken);
        const hour = new Date().getHours();
        const thisTime = hour < 8 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 18 ? '下午好' : '晚上好';
        Vue.prototype.$baseNotify(`欢迎回来!`, `${thisTime}！`);
        return true;
      } else {
        Vue.prototype.$baseMessage(`登录接口异常，未正确返回${tokenName}...`, 'error');
        return false;
      }
    } else {
      Vue.prototype.$baseMessage(userRes.result, 'error');
      return false;
    }
  },
  /**
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * 在路由守卫中使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit, dispatch, state }) {
    let userInfo = await getUserDetails();
    console.log('userInfo: ', userInfo);

    const { name, id, menu, project, ability, orgId, orgName } = userInfo.result;

    let prjRoleData = (await getprjRoleInfoAPI({ prjId: state.prjId, userId: id })).result;
    const roles = prjRoleData.userRoles ? prjRoleData.userRoles : userInfo.result.roles;

    // 必须携带username和avatar
    if (name && (!roles || (roles && isArray(roles))) && (!ability || (ability && isArray(ability)))) {
      // 当不传递roles或ability时,默认使用管理员权限,可查看所有路由和按钮
      if (!roles && !ability) dispatch('acl/setFull', true, { root: true });
      // 当返回数据包含roles(角色)或ability(权限),保存至vuex
      // 如不使用roles权限控制,请不要传递roles,可删除以下代码

      if (roles) await dispatch('getprjRoleInfo', { prjId: state.prjId, userId: id });

      // 如不使用ability权限控制,请不要传递ability,可删除以下代码
      // if (ability) dispatch('acl/setAbility', ability, { root: true })
      commit('setUsername', name); //ok
      commit('setUserId', id); //ok
      //
      commit('setOrgId', orgId); //ok
      commit('setOrgName', orgName); //ok
      commit('setUserMenu', menu); //待修改  要根据 登陆人+选择的项目切换菜单
      commit('setPrjList', project);
      commit('setAvatar', 'http://bim.sinoma-tianjin.com:8091/Content/UserHeads/default.png'); //https://i.gtimg.cn/club/item/face/img/2/15922_100.gif
    } else {
      Vue.prototype.$baseMessage('getUserInfo核心接口异常，请检查返回JSON格式是否正确', 'error');
      return Promise.reject();
    }
  },

  /**
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    //
    await dispatch('resetAll');
  },
  /**
   * @description 重置accessToken、roles、ability、router、tabsBar等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ commit, dispatch }) {
    commit('setUsername', '');
    commit('setUserId', '');
    commit('setPrjList', []);
    commit('setAvatar', 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif');
    await dispatch('setAccessToken', '');
    commit('setRoles', []);
    await dispatch('tabsBar/delAllVisitedRoutes', [], { root: true });
    await resetRouter();
    removeAccessToken();
    clearAllCookie(); //清除顶级域名下所有cookie函数  彭妙培    20230110
  },
  /**
   * @description 设置token
   */
  setAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken);
  },

  /**
   * 获取当前登录人可以看到的项目数据
   *
   *
   */
  async getPrjList({ state }, user) {
    let data = { userId: user };
    state.prjList = (await getPrjListbyUser(data)).result;
    //state.prjList = (await getPrjListbyUser(user)).result
  },
  async getPrjListMarket({ state }, user) {
    let data = { userId: user };
    state.prjListMarket = (await getPrjListbyUserMarket(data)).result;
  },

  async getPrjListDesign({ state }, data) {
    for (var i = 0; i < data.typeList.length; i++) {
      if (data.typeList[i].label.indexOf('设计') != -1) {
        let postdata = { userId: data.userId, type: data.typeList[i].value };
        state.prjListDesign[data.typeList[i].value] = (await getPrjListbyUserDesign(postdata)).result.map((element) => {
          if ((element.parentID = '00000000-0000-0000-0000-000000000000')) {
            element.title = element.title.split('-')[1];
          }
          return element;
        });
      }
    }
  },

  /**
   * @description: 异步更改项目中人员角色，获取该项目中登录人的roles
   * @param {*} commit
   * @param {*} dispatch
   * @param {*} state
   * @param {*} data   选择的项目id+登录人id
   * @return {*}
   */
  async getprjRoleInfo({ commit, dispatch, state }, prjRoleInfo) {
    let data = (await getprjRoleInfoAPI(prjRoleInfo)).result;

    // //0.如果角色组包含1，设置admin:true
    if (data.userRoles.indexOf('1') > 0) {
      await dispatch('acl/setFull', true, { root: true });
    } else {
      await dispatch('acl/setFull', false, { root: true });
    }

    await dispatch('acl/setRole', data.userRoles, { root: true });
    await commit('setMajors', data.userMajor);
    await commit('setUserTopRole', data.userTopRole);
    await commit('setmajorroleMap', data.majorroleMap); //majorroleMap
    await commit('setIsFilterTask', data.isFilterTask);
    await commit('setTaskCodes', data.taskCodes);

    await dispatch('routes/setRoutes', authentication, { root: true });

    return data.userRoles;
  },
};
export default { state, getters, mutations, actions };
